require("mobx-react-lite/batchingForReactDom")
